/**
 * @generated SignedSource<<662a17f5f90a757e24a3cc252fafb312>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PieceRendererNoteTooltip_note$data = {
  readonly page_id: string;
  readonly note_id: string;
  readonly bulb_id: string;
  readonly midi_number: number;
  readonly note_start: number;
  readonly note_duration: number;
  readonly " $fragmentSpreads": FragmentRefs<"PieceRendererViewAttributes_note" | "PieceRendererNoteChangeDuration_note">;
  readonly " $fragmentType": "PieceRendererNoteTooltip_note";
};
export type PieceRendererNoteTooltip_note$key = {
  readonly " $data"?: PieceRendererNoteTooltip_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"PieceRendererNoteTooltip_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PieceRendererNoteTooltip_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "page_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "note_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bulb_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "midi_number",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "note_start",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "note_duration",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PieceRendererViewAttributes_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PieceRendererNoteChangeDuration_note"
    }
  ],
  "type": "MusicPieceFileNote",
  "abstractKey": null
};

(node as any).hash = "2ca61d6965defde783dd33d93b9992c0";

export default node;
